import React, { useState, useEffect } from 'react';
import './SplashScreen.css';

interface SplashScreenProps {
  onComplete: () => void;
}

const SplashScreen: React.FC<SplashScreenProps> = ({ onComplete }) => {
  const [showAnimation, setShowAnimation] = useState(false);
  const [showContent, setShowContent] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Create floating particles
    const createParticles = () => {
      const container = document.querySelector('.particle-system');
      if (!container) return;

      for (let i = 0; i < 50; i++) {
        const particle = document.createElement('div');
        particle.className = 'particle';
        particle.style.left = Math.random() * 100 + '%';
        particle.style.animationDuration = (Math.random() * 3 + 2) + 's';
        particle.style.animationDelay = Math.random() * 2 + 's';
        container.appendChild(particle);
      }
    };

    createParticles();

    const timer1 = setTimeout(() => setShowAnimation(true), 300);
    const timer2 = setTimeout(() => setShowContent(true), 1000);
    
    // Progress animation
    const progressTimer = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(progressTimer);
          setTimeout(onComplete, 500);
          return 100;
        }
        return prev + 2;
      });
    }, 50);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearInterval(progressTimer);
    };
  }, [onComplete]);

  return (
    <div className="splash-screen">
      <div className="splash-background">
        <div className="particle-system"></div>
        
        <div className="splash-content">
          <div className={`logo-container ${showAnimation ? 'animate' : ''}`}>
            <div className="logo-wrapper">
              <img 
                src="/nrtr-logo-circle.png" 
                alt="NRTR Logo" 
                className="splash-logo"
              />
              <div className="logo-glow"></div>
              <div className="logo-ring"></div>
            </div>
            
            <div className="brand-info">
              <h1 className="brand-title">NRTR</h1>
              <p className="brand-subtitle">Network Management Platform</p>
            </div>
          </div>
          
          <div className={`welcome-text ${showContent ? 'visible' : ''}`}>
            <div className="welcome-badge">
              <span className="badge-icon">🎉</span>
              <span>Welcome to NRTR Demo</span>
            </div>
            
            <div className="welcome-message">
              <p className="seed-message">
                <span className="highlight">The seed is planted</span>—now it's time to watch your network bloom 🪴
              </p>
              
              <p className="premium-message">
                For the next <strong>3 months</strong>, you'll enjoy access to our 
                <span className="premium-highlight"> Premium Features</span> at no cost.
              </p>
            </div>
          </div>
          
          <div className={`loading-animation ${showContent ? 'visible' : ''}`}>
            <div className="loading-container">
              <div className="loading-bar">
                <div 
                  className="loading-progress" 
                  style={{ width: `${progress}%` }}
                ></div>
                <div className="loading-shimmer"></div>
              </div>
              <div className="loading-info">
                <p className="loading-text">Preparing your dashboard...</p>
                <span className="loading-percentage">{progress}%</span>
              </div>
            </div>
            
            <div className="feature-preview">
              <div className="feature-item">
                <span className="feature-icon">📊</span>
                <span>Analytics</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">🔗</span>
                <span>Integrations</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">🚀</span>
                <span>Campaigns</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen; 